var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-wrapper',[_c('widget-balance',{staticClass:"mt-4"}),_c('nav-menu',{staticClass:"mt-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }